
<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="AccessId" prop="accessId">
        <Input v-model="editModel.accessId" placeholder=""></Input>
      </FormItem>
      <FormItem label="AchiveApi" prop="achiveApi">
        <Input v-model="editModel.achiveApi" placeholder=""></Input>
      </FormItem>

      <FormItem label="DImageUrl" prop="dImageUrl">
        <Input v-model="editModel.dImageUrl" placeholder=""></Input>
      </FormItem>
      <FormItem label="EUnityAddress" prop="eUnityAddress">
        <Input v-model="editModel.eUnityAddress" placeholder=""></Input>
      </FormItem>
      <FormItem label="EUnityUser" prop="eUnityUser">
        <Input v-model="editModel.eUnityUser" placeholder=""></Input>
      </FormItem>
      <!-- <FormItem label="HospitalCode" prop="hospitalCode">
        <Input v-model="editModel.hospitalCode" placeholder=""></Input>
      </FormItem> -->

      <FormItem label="MaxDays" prop="maxDays">
        <Input v-model="editModel.maxDays" placeholder=""></Input>
      </FormItem>

      <FormItem label="ProductCode" prop="productCode">
        <Input v-model="editModel.productCode" placeholder=""></Input>
      </FormItem>
      <FormItem label="Secret" prop="secret">
        <Input v-model="editModel.secret" placeholder=""></Input>
      </FormItem>
      <FormItem label="ServerName" prop="serverName">
        <Input v-model="editModel.serverName" placeholder=""></Input>
      </FormItem>
      <!-- <input v-model="editModel.iD" placeholder="" type="hidden"></input>
      <input v-model="editModel.organID" placeholder="" type="hidden"></input> -->
    </Form>
    <div class="text-center">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>
  </div>
</template>
<script>
import token from "../../../utils/token.js";
export default {
  props: ["currentId"],
  data: function () {
    return {
      editModel: {
        accessId: "",
        achiveApi: "",
        organID: "",
        deleteFlag: "",
        dImageUrl: "",
        eUnityAddress: "",
        eUnityUser: "",
        hospitalCode: "",
        iD: "",
        maxDays: 0,
        productCode: "",
        secret: "",
        serverName: "",
      },

      ruleValidate: {
        // accessId: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // achiveApi: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // createDate: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // deleteFlag: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // dImageUrl: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // eUnityAddress: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // eUnityUser: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // hospitalCode: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // iD: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // maxDays: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // organCode: [
        //   {
        //     required: true,
        //     message: "机构编号不能为空",
        //   },
        // ],
        // organID: [
        //   {
        //     required: true,
        //     message: "机构ID不能为空",
        //   },
        // ],
        // organName: [
        //   {
        //     required: true,
        //     message: "机构名不能为空",
        //   },
        // ],
        // productCode: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // secret: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        // serverName: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
      },
    };
  },

  created: function () {
    let baseUrl = localStorage.getItem("baseURL");

    this.editModel.organID = this.currentId;
    var current = this;
    this.$api
      .post("organ/GetHospitalInfoByOrgan?OrganID=" + this.currentId)
      .then((rsp) => {
        console.log(rsp);
        if (rsp.data) {
          current.editModel = rsp.data;
          current.editModel.hospitalCode = current.currentId;
        }
      });
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api
            .post("organ/HospitalInfoUpdate", this.editModel)
            .then((rsp) => {
              if (rsp != false) {
                this.$Message.success("更新成功");
                this.returnBack();
                this.resetData();
                this.$emit("loadData");
              }
            });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
  },
};
</script>
<style scoped>
</style>